import { IInputStatus } from '../../../interface/progress.interface'
import { IChangeValue } from '../../../interface/steps.interface'
import { IStringInputSettings } from '../inputs.interface'
import String from '../String/String'
import { useDate } from './useDate'

interface Props {
  value: string
  name: string
  handleChange: IChangeValue
  status: IInputStatus
  settings: IStringInputSettings
  apiErrors: { [name: string]: string }
  progressTrigger?: Function
  checkChangeValue: Function
  tooltip?: string
}

const Date = ({
  value,
  name,
  handleChange,
  status,
  settings,
  apiErrors,
  progressTrigger,
  checkChangeValue,
  tooltip
}: Props) => {
  console.log('Date', value)
  const {
    localValue,
    localStatus,
    inputRef,
    disabled,
    localSettings,
    handleLocalChange,
    handleKeydown,
    handlePaste,
    handleFocus,
    handleBlur,
  } = useDate({
    value,
    name,
    handleChange,
    status,
    settings,
    progressTrigger,
    checkChangeValue
  })

  return (
    <String
      value={localValue}
      name={name}
      status={localStatus}
      disabled={disabled}
      apiErrors={apiErrors}
      innerRef={inputRef}
      settings={localSettings}
      handleChange={handleLocalChange}
      handleKeydown={handleKeydown}
      handlePaste={handlePaste}
      handleFocus={handleFocus}
      handleBlur={handleBlur}
      tooltip={tooltip}
    />
  )
}

export default Date
